import script from "./LlResizableTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./LlResizableTextarea.vue?vue&type=script&setup=true&lang=js"

import "./LlResizableTextarea.vue?vue&type=style&index=0&id=5c3b9a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3b9a9e"]])

export default __exports__